<script lang="ts">
	import type { Snippet } from 'svelte';

	const {
		details,
		children,
		...rest
	}: { details: string; children: Snippet; class?: string; [key: string]: unknown } = $props();
</script>

<details class={['group', rest?.class]} open>
	<summary
		class="flex cursor-pointer list-none justify-between text-2xl font-semibold marker:hidden"
	>
		<div>{details}</div>
		<div class="flex items-center justify-center text-4xl">
			<div class="block group-open:hidden">+</div>
			<div class="hidden group-open:block">-</div>
		</div>
	</summary>
	{@render children()}
</details>
